import { Box } from '@mui/material';
import React, { type ReactNode } from 'react';

import AttachmentsDragOverlay from './AttachmentsDragOverlay';

interface AttachmentsDropzoneProps {
  isDragging: boolean;
  onDragEnter: (e: React.DragEvent) => void;
  onDragLeave: (e: React.DragEvent) => void;
  onDragOver: (e: React.DragEvent) => void;
  onDrop: (e: React.DragEvent) => void;
  children: ReactNode;
}

const AttachmentsDropzone: React.FC<AttachmentsDropzoneProps> = ({
  isDragging,
  onDragEnter,
  onDragLeave,
  onDragOver,
  onDrop,
  children,
}) => (
  <Box
    sx={{
      flex: 1,
      overflow: 'auto',
      position: 'relative',
      minHeight: 120,
    }}
    onDragEnter={onDragEnter}
    onDragLeave={onDragLeave}
    onDragOver={onDragOver}
    onDrop={onDrop}
  >
    <AttachmentsDragOverlay visible={isDragging} />
    {children}
  </Box>
);

export default AttachmentsDropzone;
